import React from "react";
import Error from "../../components/Navbar/ui/Error";
import Loading from "../../components/Navbar/ui/Loading";
import { useGetProjectsQuery } from "../../features/projects/projectApi";
import Project from "./Project";

export default function ProjectList() {
  const {
    data: projects,
    isLoading,
    isError,
    error,
  } = useGetProjectsQuery() || {};

  // Decided what to render
  let content = null;
  if (isLoading) {
    content = <Loading />;
  } else if (!isLoading && isError) {
    content = <Error header="Error!!" message={error?.message} />;
  } else if (!isLoading && !isError && projects?.length === 0) {
    content = <Error header="Warning" message="No Project Found" />;
  } else if (!isLoading && !isError && projects?.length > 0) {
    content = projects.map((project) => (
      <Project key={project?.id} project={project} />
    ));
  }

  return (
    <div>
      <h3 className="text-xl font-bold">Projects</h3>
      <div className="mt-3 space-y-4">{content}</div>
    </div>
  );
}
